export function upperCaseWithUnderscores(text: string): string {
    return text
        .replace(/([^^A-Z])([A-Z])/g, '$1_$2')
        .replace(/\s/g, '_')
        .toUpperCase();
}
